import {Component, input} from '@angular/core';
import {EvaluationCriteria} from '@frontend/directus';
import {SubCriteriaAttributeItem} from '../../../subcriteria-attribute-evaluation/subcriteria-attribute-evaluation.types';
import {
  BarChartConfig,
  ProgressDashboardGenericBarChartComponent,
} from '../progress-dashboard-generic-bar-chart.component';

const EC_BAR_CHART_CONFIG: BarChartConfig<EvaluationCriteria> = {
  getNumberFromAttribute: (attribute) => attribute.ecNumber,
  findCriteriaByNumber: (criteria, number) => criteria.find((ec) => ec.ecNumber === number),
  getTranslations: (criteria) => criteria.translations,
  sortDescending: false,
};

@Component({
  selector: 'app-progress-dashboard-rfp-bar-chart-container',
  imports: [ProgressDashboardGenericBarChartComponent],
  template: `
    <app-progress-dashboard-generic-bar-chart
      [label]="label()"
      [subCriteriaAttributes]="subCriteriaAttributes()"
      [criteria]="evaluationCriteria()"
      [config]="chartConfig"
    />
  `,
})
export class ProgressDashboardRfpBarChartComponent {
  readonly label = input.required<string>();
  readonly subCriteriaAttributes = input.required<SubCriteriaAttributeItem[]>();
  readonly evaluationCriteria = input.required<EvaluationCriteria[]>();

  protected readonly chartConfig = EC_BAR_CHART_CONFIG;
}
